import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import Launch from './components/Launch/Launch';
import './App.css';

function App() {
  
  return (
    <BrowserRouter>
      <div className="app">
        <Launch />
      </div>
    </BrowserRouter>
  );
}

export default App;
